import { ITelegramAccountRepository } from '../../ports/ITelegramAccountRepository';

export class StartTelegramAccountAuthUseCase {
  constructor(private repo: ITelegramAccountRepository) {}
  async execute(uuid: string): Promise<void> { return this.repo.startAuth(uuid); }
}
